import { Resources } from 'constants/resources';

import { useState } from 'react';

import { AxiosResponse } from 'axios';
import { createOrderManual, OrderManualCreatePayload } from 'config/requests/orderManual';
import { format } from 'date-fns';
import omit from 'lodash/omit';
import { useNotify, useRedirect } from 'react-admin';

import { OrderManualCreateValues } from '../OrderManualCreate';

const formatDate = (ms: number | null) => (ms ? format(ms, 'yyyy-MM-dd HH:mm:ss') : '');

export const useOrderManualCreate = () => {
  const [isLoading, setIsLoading] = useState(false);
  const notify = useNotify();
  const redirect = useRedirect();

  const onSubmit = async (values: OrderManualCreateValues) => {
    const data: OrderManualCreatePayload = {
      ...omit(values, [
        'currencyId',
        'countryId',
        'merchant',
        'merchantAccount',
        'provider',
        'gateway',
        'method',
      ]),
      createdAt: formatDate(values.createdAt),
      updatedAt: formatDate(values.updatedAt),
    };

    setIsLoading(true);

    try {
      const response = await createOrderManual(data);

      notify('Заказ создан', { type: 'success' });
      redirect('show', Resources.Orders, response.data.order.id);
    } catch (error) {
      const response = error as AxiosResponse | undefined;

      notify(response?.data.errors[0].title || 'Не удалось создать заказ', {
        type: 'error',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return {
    onSubmit,
    isLoading,
  };
};
